<template>
  <ElButton :icon="Icons.easySearchReset" @click="search"></ElButton>
</template>

<script lang="ts" setup>
import { ElButton } from 'element-plus';
import { useShareData } from '../../core/SharedData';
import { Pagination } from '../types';
import { Icons } from '../../common/Icons';

const reset = useShareData('search', 'reset');

// 分页参数
const pagination = useShareData('search', 'pagination') as Pagination;
async function search() {
  pagination.page = 1;
  await reset();
}
</script>
